import { render, staticRenderFns } from "./restricted_area.vue?vue&type=template&id=7857d78c"
import script from "./restricted_area.vue?vue&type=script&lang=js"
export * from "./restricted_area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports